export default "__VITE_ASSET__CXKMReu6__"